const getCustomerShippingMethodsCommand = {
  execute: async (context, params) => {
    var _a, _b, _c;
    const {
      data: { customerCart: { shipping_addresses: shippingAddresses } }
    } = await context.$magento.api.getAvailableCustomerShippingMethods((_a = params == null ? void 0 : params.customQuery) != null ? _a : null, params == null ? void 0 : params.customHeaders);
    return (_c = (_b = shippingAddresses[0]) == null ? void 0 : _b.available_shipping_methods) != null ? _c : [];
  }
};
export {
  getCustomerShippingMethodsCommand
};
